import React, { Component } from 'react';

import { Form, Row, Col, Input, Modal, message, DatePicker, Checkbox, Select, Upload, Button, Icon } from 'antd';
import { Message } from 'semantic-ui-react'
import moment from 'moment';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import QuestionnaireOpMode from '../../../../utils/QuestionnaireOpMode';
import { QUESTIONNAIRE_TYPE_MAP } from '../../../../utils/QuestionnaireType';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

// Questionnaire Type
const QuestionnaireTypeOptions = [];
for (let i = 0; i < QUESTIONNAIRE_TYPE_MAP.length; i++) {
  QuestionnaireTypeOptions.push(<Option key={QUESTIONNAIRE_TYPE_MAP[i].code}>{QUESTIONNAIRE_TYPE_MAP[i].label}</Option>);
}

class QuestionnaireEditDialog extends Component {
  state = {
    
  };

  onInputChange = ({ name, value }) => {
    this.props.questionnaireEditChangeInput({ name, value });
  };

  componentDidUpdate() {
    const { 
      createQuestionnaireActionStatus,
      updateQuestionnaireActionStatus,
      copyQuestionnaireActionStatus,
    } = this.props;

    // 创建 Questionnaire 成功
    if (createQuestionnaireActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Questionnaire is created successfully!');
      this.props.loadQuestionnaires();
      this.props.initCreateQuestionnaireActionStatus();

      this.props.form.resetFields();
      this.props.resetQuestionnaireEditModalDialog();
    } 

    // 创建 Questionnaire 失败
    if (createQuestionnaireActionStatus === ACTION_STATUS.ERROR) {
      message.error('Questionnaire is created failed!');
      this.props.initCreateQuestionnaireActionStatus();
    }

    // 更新 Questionnaire 成功
    if (updateQuestionnaireActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Questionnaire is updated successfully!');
      const {
        questionnaireVersion,
        nameOnQuestionnaire,
        status,
      } = this.props.questionnaireQueryFields;
      this.props.loadQuestionnaires({ questionnaireVersion, nameOnQuestionnaire, status });
      this.props.initUpdateQuestionnaireActionStatus();

      this.props.form.resetFields();
      this.props.resetQuestionnaireEditModalDialog();
    } 

    // 更新 Questionnaire 失败
    if (updateQuestionnaireActionStatus === ACTION_STATUS.ERROR) {
      message.error('Questionnaire is updated failed!');
      this.props.initUpdateQuestionnaireActionStatus();
    }

    // Copy Questionnaire 成功
    if (copyQuestionnaireActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Questionnaire is copied successfully!');
      this.props.loadQuestionnaires();
      this.props.initCopyQuestionnaireActionStatus();

      this.props.form.resetFields();
      this.props.resetQuestionnaireEditModalDialog();
    } 

    // Copy Questionnaire 失败
    if (copyQuestionnaireActionStatus === ACTION_STATUS.ERROR) {
      message.error('Questionnaire is copied failed!');
      this.props.initCopyQuestionnaireActionStatus();
    }
  }

  // Submit Create/Edit Member
  submitButtonOnClicked = () => {
    const {
      questionnaireEditControlModal,
    } =  this.props;

    const {
      mode,
      fields,
    } =  questionnaireEditControlModal;

    const {
      guid,
      name,
      title,
      isActive,
      expiredDate,
      attachment,
      attachmentOriginName,
      type,
    } = fields;

    const form = this.props.form;

    // 表单校验
    form.validateFields((err) => {
        if (!err) {
          console.info('success');

          if (mode === QuestionnaireOpMode.NEW) {
            this.props.createQuestionnaire({
              guid,
              name,
              title,
              isActive,
              expiredDate,
              attachment,
              attachmentOriginName,
              type,
            });
          } 
          
          if (mode === QuestionnaireOpMode.MODIFY) {
            this.props.updateQuestionnaire({
              guid,
              name,
              title,
              isActive,
              expiredDate,
              attachment,
              attachmentOriginName,
              type,
            });
          }

          if (mode === QuestionnaireOpMode.COPY) {
            this.props.copyQuestionnaire({
              guid,
              name,
              title,
              isActive,
              expiredDate,
              attachment,
              attachmentOriginName,
              type,
            });
          }
        }
      },
    );
  }

  // 附件上传
  attachmentHandleChange = (info) => {
    let fileList = [...info.fileList]; 
    // fileList = fileList.slice(-1);
    this.props.questionnaireEditChangeInput({name: 'fileList', value: fileList});

    let fileNameArray = [];
    let originalFileNameArray = [];
    fileList.forEach(file => {
      if (file.response) {
        const fileName = file.response.data.fileNameWithTimeStamp;
        const originalFileName = file.response.data.originalFileName;
        
        fileNameArray.push(fileName);
        originalFileNameArray.push(originalFileName);
      }
    });

    if (fileList.length === fileNameArray.length) {
      const fileNames = fileNameArray.join(',');
      const originalFileNames = originalFileNameArray.join(',');
      this.props.questionnaireEditChangeInput({name: 'attachment', value: fileNames});
      this.props.questionnaireEditChangeInput({name: 'attachmentOriginName', value: originalFileNames});
    }
  }

  // 删除
  attachmentHandleRemove = (file) => {
    const {
      fileList,
    } =  this.props.questionnaireEditControlModal.fields;

    const fileListWithoutRemovedFile = fileList.filter(fileItem => fileItem.uid !== file.uid);
    this.props.questionnaireEditChangeInput({name: 'fileList', value: fileListWithoutRemovedFile});

    let fileNameArray = fileListWithoutRemovedFile.map(fileItem => fileItem.response.data.fileNameWithTimeStamp);
    let originalFileNameArray = fileListWithoutRemovedFile.map(fileItem => fileItem.response.data.originalFileName);
    
    const fileNames = fileNameArray.join(',');
    const originalFileNames = originalFileNameArray.join(',');
    this.props.questionnaireEditChangeInput({name: 'attachment', value: fileNames});
    this.props.questionnaireEditChangeInput({name: 'attachmentOriginName', value: originalFileNames});
  }

  questionnaireTypeChanged = (val) => {
    this.onInputChange({ name: 'type', value: val });
  }

  render() {
    const {
      questionnaireEditControlModal,
      createQuestionnaireActionStatus,
      updateQuestionnaireActionStatus,
      copyQuestionnaireActionStatus,

      // 问卷附件上传Url
      questionnaireAttachmentUploadUrl,
    } = this.props;

    const {
      isOpened,
      mode,
      respErrMsg,
    } = questionnaireEditControlModal;


    const { getFieldDecorator } = this.props.form;

    const {
      name,
      title,
      isActive,
      expiredDate,
      fileList,
      type
    } = questionnaireEditControlModal.fields;

    let modalTitle = "Add Questionnaire";
    if (mode === QuestionnaireOpMode.MODIFY) {
      modalTitle = "Edit Questionnaire";
    } else if (mode === QuestionnaireOpMode.COPY) {
      modalTitle = "Copy Questionnaire";
    }

    const isLoading = createQuestionnaireActionStatus === ACTION_STATUS.LOGINING || 
      updateQuestionnaireActionStatus === ACTION_STATUS.LOGINING || copyQuestionnaireActionStatus === ACTION_STATUS.LOGINING; 

    return (
      <div>
        <Modal
          title={modalTitle}
          centered
          width={600}
          visible={isOpened}
          confirmLoading={isLoading}
          onOk={this.submitButtonOnClicked}
          onCancel={() => this.props.resetQuestionnaireEditModalDialog()}
          destroyOnClose={true}
          maskClosable={false}
          okText="Submit"
          cancelText="Cancel"
        >
          <Form layout="horizontal">
            <Row gutter={24}>
              <Col span={24}>
                <FormItem {...formItemLayout} label="Name">
                  {getFieldDecorator('name', {
                    initialValue: name,
                    rules: [{
                      required: true,
                      message: 'Please input questionnaire name',
                    }],
                  })(
                    <Input placeholder="Questionnaire Name" 
                      onChange={(e) => {
                          this.onInputChange({ name: 'name', value: e.target.value })
                        }}
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <FormItem {...formItemLayout} label="Title">
                  {getFieldDecorator('title', {
                    initialValue: title,
                    rules: [{
                      required: true,
                      message: 'Please input title',
                    }],
                  })(
                    <Input placeholder="Questionnaire Title" 
                      onChange={(e) => {
                        this.onInputChange({ name: 'title', value: e.target.value })
                      }}
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <FormItem {...formItemLayout} label="Active">
                  <Checkbox 
                    checked={isActive}
                    onChange={(e) => {
                      this.onInputChange({ name: 'isActive', value: e.target.checked })
                    }}
                    ></Checkbox>
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <FormItem {...formItemLayout} label="Expired Date">
                  {getFieldDecorator('expiredDate', {
                    initialValue: expiredDate === '' ? null : moment(expiredDate),
                    rules: [{
                      required: true,
                      message: 'Please select expired date',
                    }],
                  })(
                    <DatePicker 
                      allowClear={false}
                      disabledDate={(currentDate) => {
                        return currentDate && currentDate.isBefore(moment().startOf('day'))
                      }}
                      onChange={(date, dateString) => {
                        this.onInputChange({ name: 'expiredDate', value: dateString });
                      }} />
                    )
                  }
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <FormItem {...formItemLayout} label="Type">
                  {getFieldDecorator('type', {
                      initialValue: type,
                      rules: [{
                        required: true,
                        message: 'Please choose Type',
                      }],
                  })(
                      <Select 
                        value={type}
                        onChange={this.questionnaireTypeChanged} 
                        placeholder="Please Choose">
                        {QuestionnaireTypeOptions}
                      </Select>
                  )}
                </FormItem>
              </Col>
            </Row>
            {/* <Row gutter={24}>
              <Col span={24}>
                <FormItem {...formItemLayout} label="Attachment">
                  <Upload
                    name="attachment"
                    multiple={true}
                    showUploadList={true}
                    fileList={fileList}
                    action={questionnaireAttachmentUploadUrl}
                    onChange={this.attachmentHandleChange}
                    onRemove={this.attachmentHandleRemove}
                  >
                    <Button>
                      <Icon type="upload" /> Template of Questionnaire
                    </Button>
                  </Upload>
                </FormItem>
              </Col>
            </Row> */}
          </Form>
          {
            !!respErrMsg &&  
            <Message negative>
                <Message.Header>Response Error Message</Message.Header>
              <p>{ respErrMsg }</p>
            </Message>
          }
        </Modal>
      </div>
    );
  }
}

const QuestionnaireEditDialogForm = Form.create({ name: 'questionnaire_edit_dialog' })(QuestionnaireEditDialog);

export default QuestionnaireEditDialogForm;
